export function convertDateToLocalDate(dateString){
    const options = {day: '2-digit', month: '2-digit', year: '2-digit', timeZone: 'UTC'}
    return new Date(dateString).toLocaleDateString('es-ES', options).replace(/\//g, '-')
} 
export function convertDateToInputDate(dateString){
    const options = {day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC'}
    return new Date(dateString).toLocaleDateString('es-ES', options).split('/').reverse().join('-')
}
